import axios from 'axios';
import { dateFormatHadith } from '../ConstantFunctions';
import { toast } from 'react-toastify';

export const CREATE_POST_LOADER = 'CREATE_POST_LOADER';
export const createPostLoader = bool => ({
  type: 'CREATE_POST_LOADER',
  payload: bool,
});

export const createPostAction = (obj, clearState, setConfirmLoader) => {
  return async dispatch => {
    dispatch(createPostLoader(true));
    setConfirmLoader(true);

    let data = new FormData();
    for (let key in obj) {
      if (obj[key] || obj[key] === null) {
        if (key === 'content') {
          data.append(key, JSON.stringify(obj[key]));
          continue;
        }
        data.append(key, obj[key]);
      }
    }

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/create?${obj.book ? `book=${obj.book}&` : ''}${
        obj.volume ? `volume=${obj.volume}&` : ''
      }${obj.bookId ? `bookId=${obj.bookId}&` : ''}${obj.categories ? `categories=${obj.categories.join(',')}&` : ''}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: data,
    };

    axios(config)
      .then(response => {
        dispatch(createPostData(response.data.data));
        dispatch(createPostLoader(false));
        setConfirmLoader(false);
        toast.success('Post Has Been Created, Please Publish Your Post Or Save To Draft ');
        clearState();
      })
      .catch(error => {
        setConfirmLoader(false);
        toast.error('something went wrong');
        dispatch(createPostLoader(false));
      });
  };
};

export const updatePostAction = (
  obj,
  id,
  clearState,
  status,
  handleOk,
  setConfirmLoader,
  bookId,
  volume,
  categories,
  textSearch,
  bookIdSearch,
  volumeIdSearch
) => {
  return async dispatch => {
    dispatch(createPostLoader(true));
    if (setConfirmLoader) {
      setConfirmLoader(true);
    }
    delete obj._id;
    delete obj.__v;
    delete obj.updatedAt;
    delete obj.createdAt;
    delete obj.views;
    delete obj.recitation_audio_url;
    let data = new FormData();

    for (let key in obj) {
      if (key === 'content') {
        data.append(key, JSON.stringify(obj[key]));
        continue;
      }
      data.append(key, obj[key]);
    }

    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/update?id=${id}&${bookId ? `book=${bookId}&` : ''}${
        volume ? `volume=${volume}&` : ''
      }${bookId ? `bookId=${bookId}&` : ''}${categories ? `categories=${categories.join(',')}&` : ''}`,
      headers: {
        'content-type': 'multipart/form-data',
        // 'content-type': 'application/json',
      },
      data: data,
    };

    axios(config)
      .then(response => {
        dispatch(createPostData(response.data.data));
        dispatch(getAllPostSearchAction(textSearch, bookIdSearch, volumeIdSearch));
        dispatch(createPostLoader(status));
        dispatch(getAllPostAction(status));
        if (clearState) {
          clearState();
        }
        if (handleOk) {
          handleOk();
        }
        if (setConfirmLoader) {
          setConfirmLoader(false);
        }
        toast.success('Post Has Been Updated');
      })
      .catch(error => {
        dispatch(createPostLoader(false));
        if (setConfirmLoader) {
          setConfirmLoader(false);
        }
        toast.error('something went wrong');
      });
  };
};

export const updatePostStatusAction = (obj, setPublishLoader, notShow) => {
  return async dispatch => {
    setPublishLoader(true);

    let config = {
      method: 'patch',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/updatestatus`,
      headers: {
        'content-type': 'application/json',
      },
      data: obj,
    };

    axios(config)
      .then(response => {
        dispatch(createPostData(response.data.data));
        dispatch(createPostLoader(false));
        setPublishLoader(false);
        if (!notShow) {
          toast.success('Post Has Been Updated');
        }
        // clearState()
      })
      .catch(error => {
        setPublishLoader(false);
        dispatch(createPostLoader(false));
        toast.error('something went wrong');
      });
  };
};

export const GET_POST_LOADER = 'GET_POST_LOADER';
export const getPostLoader = bool => ({
  type: 'GET_POST_LOADER',
  payload: bool,
});

export const getPostAction = (book, volume, bookId, categories) => {
  return async dispatch => {
    dispatch(getPostLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/getPost?${book ? `book=${book}&` : ''}${volume ? `volume=${volume}&` : ''}${
        bookId ? `bookId=${bookId}&` : ''
      }${categories ? `categories=${categories.join(',')}&` : ''}`,
      headers: {},
    };

    axios(config)
      .then(response => {
        dispatch(createPostData(response.data.data));
        dispatch(getPostLoader(false));
      })
      .catch(error => {
        dispatch(getPostLoader(false));
      });
  };
};

export const POST_DATA_DATA = 'POST_DATA_DATA';
export const createPostData = payload => ({
  type: 'POST_DATA_DATA',
  payload: payload,
});

export const GET_ALL_POST_LOADER = 'GET_ALL_POST_LOADER';
export const getAllPostLoader = payload => ({
  type: 'GET_ALL_POST_LOADER',
  payload: payload,
});

export const getAllPostAction = status => {
  return async dispatch => {
    dispatch(getAllPostLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/get?status=${status}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    axios(config)
      .then(response => {
        if (status === 'post') {
          dispatch(getAllPostData(response.data.data));
        } else if (status === 'draft') {
          dispatch(getAllDraftData(response.data.data));
        }
        dispatch(getAllPostLoader(false));
      })
      .catch(error => {
        dispatch(getAllPostLoader(false));
      });
  };
};

export const ALL_POST_DATA_DATA = 'ALL_POST_DATA_DATA';
export const getAllPostData = payload => ({
  type: 'ALL_POST_DATA_DATA',
  payload: payload,
});

export const ALL_DRAFT_DATA_DATA = 'ALL_DRAFT_DATA_DATA';
export const getAllDraftData = payload => ({
  type: 'ALL_DRAFT_DATA_DATA',
  payload: payload,
});

export const getAllPostSearchAction = (text, book, volume, pageNumber, pageSize) => {
  return async dispatch => {
    dispatch(getAllPostLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/postsearch?book=${book}&volume=${volume}&text=${text}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    axios(config)
      .then(response => {
        dispatch(getAllPostSearchData(response.data));
        dispatch(getAllPostLoader(false));
      })
      .catch(error => {
        dispatch(getAllPostLoader(false));
      });
  };
};

export const ALL_POST_SEARCH_DATA_DATA = 'ALL_POST_SEARCH_DATA_DATA';
export const getAllPostSearchData = payload => ({
  type: 'ALL_POST_SEARCH_DATA_DATA',
  payload: payload,
});

export const GET_SINGLE_POST_LOADER = 'GET_SINGLE_POST_LOADER';
export const getSinglePostLoader = payload => ({
  type: 'GET_SINGLE_POST_LOADER',
  payload: payload,
});

export const getSinglePostAction = id => {
  return async dispatch => {
    dispatch(getSinglePostLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/get/${id}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    axios(config)
      .then(response => {
        dispatch(getSinglePostData(response.data.data));
        dispatch(getSinglePostLoader(false));
      })
      .catch(error => {
        dispatch(getSinglePostLoader(false));
      });
  };
};

export const SINGLE_POST_DATA_DATA = 'SINGLE_POST_DATA_DATA';
export const getSinglePostData = payload => ({
  type: 'SINGLE_POST_DATA_DATA',
  payload: payload,
});

export const DELETE_SINGLE_POST_LOADER = 'DELETE_SINGLE_POST_LOADER';
export const deleteSinglePostLoader = payload => ({
  type: 'DELETE_SINGLE_POST_LOADER',
  payload: payload,
});

export const deleteSinglePostAction = (id, status, handleOk, setDeleteLoader, searchTextValue, bookId, volumeId) => {
  return async dispatch => {
    dispatch(deleteSinglePostLoader(true));
    setDeleteLoader(true);

    let config = {
      method: 'delete',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/delete/${id}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    axios(config)
      .then(response => {
        dispatch(deleteSinglePostData(response.data.data));
        dispatch(getAllPostAction(status));
        dispatch(getAllPostSearchAction(searchTextValue, bookId, volumeId));
        dispatch(deleteSinglePostLoader(false));
        setDeleteLoader(false);
        handleOk();
        toast.success('Post Has Been Deleted');
      })
      .catch(error => {
        setDeleteLoader(false);
        dispatch(deleteSinglePostLoader(false));
        toast.error('something went wrong');
      });
  };
};

export const DELETE_SINGLE_POST_DATA_DATA = 'DELETE_SINGLE_POST_DATA_DATA';
export const deleteSinglePostData = payload => ({
  type: 'DELETE_SINGLE_POST_DATA_DATA',
  payload: payload,
});
